import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login/login.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const service = inject(LoginService);
  const router = inject(Router);
  if (service.isAuthenticatedUser()) {
    return true;
  }
  router.navigate(['./login'])
  return false;
};
